import {
    Component
} from "../../../../../sedestral/framework/interface/component/Component";
import * as s from "./website-content.scss";
import {
    WebsiteIssuesComponent
} from "../white/issues/WebsiteIssuesComponent";
import {Resources} from "../../../../../resources/Resources";
import {WebsiteColumnsGridWhiteComponent} from "../white/columns/grid/WebsiteColumnsGridWhiteComponent";
import {WebsitePresentationVerticalComponent} from "../white/presentation/WebsitePresentationVerticalComponent";
import {NetworkVendor} from "../../../../../network/NetworkVendor";
import {CustomerPopup} from "../../../../panel/components/components/customer/popup/types/CustomerPopup";
import {WebsiteBlackPresentationComponent} from "../black/presentation/WebsiteBlackPresentationComponent";
import {WebsiteBlackStepsComponent} from "../black/steps/WebsiteBlackStepsComponent";
import {WebsiteSliderLeftComponent} from "../white/slider/WebsiteSliderLeftComponent";

export class WebsiteContentWebflowComponent extends Component {
    constructor() {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteContent}">
                <div class="${s.content}">
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackPresentationComponent({
                            startText: Resources.t("words.beginFree"),
                            center: true,
                            title: Resources.t("words.webflowSeoIntegrationTitle"),
                            description: Resources.t("words.webflowSeoIntegrationDescription"),
                            partnerIcon: "webflow",
                            secondButton: false,
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackStepsComponent({
                            title: Resources.t("words.generationSteps"),
                            icon: "seo",
                            contents: [
                                {
                                    name: Resources.t("words.keyword"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-e.mp4"),
                                    duration: 14000
                                },
                                {
                                    name: Resources.t("words.instructions"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-f.mp4"),
                                    duration: 8000
                                },
                                {
                                    name: Resources.t("words.plan"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-g.mp4"),
                                    duration: 21000
                                },
                                {
                                    name: Resources.t("words.writing"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-h.mp4"),
                                    duration: 15000
                                },
                            ]
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteColumnsGridWhiteComponent({
                            title: Resources.t("words.searchEngineContent"),
                            color: "black",
                            details: [{
                                icon: "black-lineal-read",
                                title: Resources.t("words.fleschReadingEase"),
                                subtitle: Resources.t("words.fleschReadingEaseSubtitle")
                            }, {
                                icon: "black-lineal-keywords",
                                title: Resources.t("words.keywords"),
                                subtitle: Resources.t("words.keywordsSubtitle")
                            }, {
                                icon: "black-lineal-words",
                                title: Resources.t("words.transitionWords"),
                                subtitle: Resources.t("words.transitionWordsSubtitle")
                            }, {
                                icon: "black-lineal-code",
                                title: Resources.t("words.htmlTagging"),
                                subtitle: Resources.t("words.htmlTaggingSubtitle")
                            }, {
                                icon: "black-lineal-voice",
                                title: Resources.t("words.passiveVoice"),
                                subtitle: Resources.t("words.passiveVoiceSubtitle")
                            }, {
                                icon: "black-lineal-seo",
                                title: Resources.t("words.seoTools"),
                                subtitle: Resources.t("words.seoToolsSubtitle")
                            }]
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteSliderLeftComponent(Resources.t("words.howItWorks"), [
                            {
                                icon: "draft",
                                title: Resources.t("words.instructionsTitle"),
                                desc: Resources.t("words.instructionsDescription"),
                                image: NetworkVendor.image("blog-h-1.webp")
                            }, {
                                icon: "paragraph",
                                title: Resources.t("words.proposalsTitle"),
                                desc: Resources.t("words.proposalsDescription"),
                                image: NetworkVendor.image("blog-h-2.webp")
                            }, {
                                icon: "section",
                                title: Resources.t("words.planTitle"),
                                desc: Resources.t("words.planDescription"),
                                image: NetworkVendor.image("blog-h-3.webp")
                            }, {
                                icon: "pensil",
                                title: Resources.t("words.writingTitle"),
                                desc: Resources.t("words.writingDescription"),
                                image: NetworkVendor.image("blog-h-4.webp")
                            }]
                        ))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteIssuesComponent({
                                    theme: "black",
                                    "questions": [
                                        {
                                            "question": Resources.t("words.doesGooglePenalizeAiContent"),
                                            "response": Resources.t("words.googleDoesNotPenalizeAiContent")
                                        },
                                        {
                                            "question": Resources.t("words.seoOptimizationQuestion"),
                                            "response": Resources.t("words.seoOptimizationResponse")
                                        },
                                        {
                                            "question": Resources.t("words.platformConnectionQuestion"),
                                            "response": Resources.t("words.platformConnectionResponse")
                                        },
                                        {
                                            "question": Resources.t("words.articleFormattingQuestion"),
                                            "response": Resources.t("words.articleFormattingResponse")
                                        },
                                        {
                                            "question": Resources.t("words.smartBlogAdvantagesQuestion"),
                                            "response": Resources.t("words.smartBlogAdvantagesResponse")
                                        }
                                    ]
                                }
                        ))}
                    </div>
                </div>
            </div>
        `;
    }

    commit() {
        CustomerPopup.blog();
        super.commit();
    }
}
